function GetCanonicalUrl() {

    if (window.canonicalurl) {
      return window.canonicalurl;
    }
    }
  export default GetCanonicalUrl;
  
  
  